module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalTitle": _vm.providerName + ' Setup'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', [_c('h2', [_vm._v("Billing Condition")]), _vm._v(" "), _c('boolean-expression-widget', {
    attrs: {
      "expression": _vm.billingCondition
    },
    on: {
      "updateExpression": _vm.updateBillingCondition
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Capacity Limits")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "group"
    }
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Hourly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.capacity.hourly),
      callback: function($$v) {
        _vm.$set(_vm.capacity, "hourly", $$v)
      },
      expression: "capacity.hourly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.capacity.hourly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Daily")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.capacity.daily),
      callback: function($$v) {
        _vm.$set(_vm.capacity, "daily", $$v)
      },
      expression: "capacity.daily"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.capacity.daily = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Weekly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.capacity.weekly),
      callback: function($$v) {
        _vm.$set(_vm.capacity, "weekly", $$v)
      },
      expression: "capacity.weekly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.capacity.weekly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.capacity.monthly),
      callback: function($$v) {
        _vm.$set(_vm.capacity, "monthly", $$v)
      },
      expression: "capacity.monthly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.capacity.monthly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f688defe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ProviderModal.vue
// module id = 680
// module chunks = 0